import { DestinationRequest } from "./destination-request";
import { OtpCustomerRequest } from "./otp-customer-request";

export class OtpRequest {
    type: string;
    channel: string;
    operationType: string;
    //amount: number;
    //currency: string;
    identifierType: string;
    customer: OtpCustomerRequest;
    destination: DestinationRequest;

    constructor(type?: string, channel?: string,
        operationType?: string, //amount?: number,
        //currency?: string, 
        identifierType?: string,
        customer?: OtpCustomerRequest, destination?: DestinationRequest) {
        this.type = type ? type : '';
        this.channel = channel ? channel : '';
        this.operationType = operationType ? operationType : '';
        //this.amount = amount ? amount : 0;
        //this.currency = currency ? currency : '';
        this.identifierType = identifierType ? identifierType : '';
        this.customer = customer ? customer : new OtpCustomerRequest();
        this.destination = destination ? destination : new DestinationRequest();
    }
}